<footer class="grid gap-2 place-items-center grid-cols-1 grid-rows-2 p-6 text-zinc-600 border-t border-zinc-200">
  <p>
    Kauê Leal de Lima © 2022 - {{currentYear}}. <i>Alguns direitos reservados.</i>
  </p>

  <span class="flex gap-2">
    <a
      target="_blank"
      rel="noopener"
      href="https://www.linkedin.com/in/kau%C3%AA-leal-de-lima-171a73247/"
      aria-label="LinkedIn"
      class="hover:bg-sky-500 hover:text-zinc-50 flex p-1.5 rounded-full transition-colors"
    >
      <i class="icon-linkedin"></i>
    </a>
    <a
      target="_blank"
      rel="noopener"
      href="https://github.com/kauelima21"
      aria-label="GitHub"
      class="hover:bg-sky-500 hover:text-zinc-50 flex p-1.5 rounded-full transition-colors"
    >
      <i class="icon-github"></i>
    </a>
  </span>
</footer>
